// extracted by mini-css-extract-plugin
export default {"root":"Home_root__3D9cb","chart":"Home_chart__8tJuc","customer":"Home_customer__zm+NJ","customerChart":"Home_customerChart__Nym+O"};